import Vue from 'vue';
import VueRouter from 'vue-router';

import Apply from '@/views/apply.vue';
import Complete from '@/views/complete.vue';
import Terms from '@/views/terms.vue';
import MonthlyParkingApply from '@/views/monthly-parking-apply.vue';
import MonthlyParkingTerms from '@/views/monthly-parking-terms.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/terms/:type',
		name: 'terms',
		component: Terms
	},
	{
		path: '/complete',
		name: 'complete',
		component: Complete
	},
	{
		path: '/apply',
		name: 'apply',
		component: Apply
	},
	{
		path: '/monthly-parking-apply',
		name: 'monthly-parking-apply',
		component: MonthlyParkingApply
	},		
	{
		path: '/monthly-parking-terms',
		name: 'monthly-parking-terms',
		component: MonthlyParkingTerms
	},		
	{
		path: '*',
		redirect: '/apply'
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

export default router;
